// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__c7olK","pagination-container":"Pagination_pagination-container__o9cCs","page-info":"Pagination_page-info__AsO7v"};